import React from 'react'

const socialMediaCss = {
    background: `grey`, 
    borderRadius: `100%`,
    width: 40,
    height: 40,
    textAlign: `center`,
    marginLeft: 20,
}

const containerCss = {
    display: `flex`,
    borderTop: `1px solid grey`,
    flexDirection: `row-reverse`,
    paddingTop: 20,
}

const ShareButtons = ({ url }) => <div css={containerCss}>
    <a
        href={`https://www.twitter.com/share?url=${url}`}
        className="site-nav-item"
        css={socialMediaCss}
        target="_blank"
        rel="noopener noreferrer"
    >
        <img
            className="site-nav-icon"
            src="/images/icons/twitter.svg"
            alt="Share on Twitter"
        />
    </a>
    <a
        href={`https://www.facebook.com/sharer.php?u=${url}`}
        className="site-nav-item"
        css={socialMediaCss}
        target="_blank"
        rel="noopener noreferrer"
    >
        <img
            className="site-nav-icon"
            src="/images/icons/facebook.svg"
            alt="Share on Facebook"
        />
    </a>
    
</div>

export default ShareButtons
